import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
export default function ProjectInbox() {
  const [data, setData] = useState({ items: [] }), [error, setError] = useState("");
  const load = useCallback(async () => {
    try { setData((await api.get("/delivery/notifications")).data); setError(""); }
    catch { setError("Could not load notifications."); }
  }, []);
  useEffect(() => { load(); }, [load]);
  async function read(item) {
    try { await api.patch(`/delivery/issues/${item._id}/notifications/${item.event._id}`, {}); await load(); }
    catch { setError("Could not mark notification as read."); }
  }
  return <section className="project-panel"><h2>Inbox</h2><button className="secondary-btn" onClick={load}>Refresh inbox</button>{error && <p role="alert">{error}</p>}{!data.items.length && <p>No unread mentions or assignments.</p>}{data.items.map((item) => <div className="project-person" key={item.event._id}><span><Link to={`/issues/${item.issueKey}`}>{item.issueKey} · {item.text}</Link><small>{item.event.message} · {new Date(item.event.at).toLocaleString()}</small></span><button className="secondary-btn" onClick={() => read(item)}>Mark read</button></div>)}{data.hasMore && <p>Showing the newest 50. Mark these as read to see older notifications.</p>}</section>;
}
